<template>
  <div class="home">
    <van-swipe :autoplay="0"  :show-indicators="false" :loop="true" style="height: 100%" >
      <van-swipe-item :style="{height:`calc(${$store.state.clientHeight}px - 3em - ${$store.state.footerHeight}px)`}"  style="width: 100vw;display: flex;flex-direction: column;justify-content: space-between;align-items: center;height: 100%" >

          <div :style="$store.state.clientWidth>=$store.state.clientHeight?{height:'60%'}:{width:'100%'}" style="display: flex;flex-direction: column;justify-content: space-evenly;align-items: center;flex-grow: 1">
            <img alt="websiteLogo" :style="$store.state.clientWidth>=$store.state.clientHeight?{maxHeight:'60%'}:{maxWidth:'60%'}"  style="object-fit: contain;" :src="images.logo">
            <h2 style="text-align: center;"  data-text="欢迎登陆GuideBook">
              <span v-for="(item,index) in '欢迎登陆GuideBook'"  :style="`--i:${index}`" :key="`huanying${index}`">{{item}}</span><br/>
              <div class="fold-unwrap">
                <span v-for="(item,index) in 'www.static.lijun.space'" :style="`--i:${index}`" :key="`jinru${index}`">{{item}}</span>
              </div>
              </h2>
          </div>

          <div style="display: flex;flex-direction: row;justify-content: center;align-items: center;color: var(--footer-color);outline: none;box-sizing: border-box;gap: 2em;padding: 1em;width: 80%">
            <i class="iconfont icon-arrow-left donghua-left" style="font-size: 1em;"></i>
            <div style="font-size: .8em">滑动页面以继续</div>
            <i class="iconfont icon-arrow-right donghua-right" style="font-size: 1em;"></i>
          </div>

      </van-swipe-item>
      <van-swipe-item :style="{height:`calc(${$store.state.clientHeight}px - 3em - ${$store.state.footerHeight}px)`}">

                <div style="overflow: auto" :style="{height:`calc(${$store.state.clientHeight}px - 3em - ${$store.state.footerHeight}px)`}">
                  <van-cell v-for="(item,index) in routeList" is-link :to="item.path" clickable :key="`custom__menu__${index}`">
                    <template #title>
                      <div style="width: 100%;display: flex;flex-direction: row;justify-content: space-between;align-items: center">
                        <div class="icon-and-title">
                          <i class="iconfont" v-if="item.meta.icon" :class="item.meta.icon"></i>
                          <div>{{item.meta.name||'未命名页面'}}</div>
                        </div>
                        <div style="height: 100%;display: flex;flex-direction: row;justify-content: center;align-items: center;gap: .5em" v-if="item.meta.hasOwnProperty('tag')">
                          <van-tag plain type="primary"  v-for="(i,indexes) in item.meta.tag.split(',')" :key="`page-view_${index}_tag_${indexes}`" size="small">{{i}}</van-tag>
                        </div>
                      </div>
                    </template>
                  </van-cell>
                </div>

      </van-swipe-item>
      <van-swipe-item :style="{height:`calc(${$store.state.clientHeight}px - 3em - ${$store.state.footerHeight}px)`}">
        <div>{{$store.state.clientHeight}}px</div>
        <div>{{$store.state.clientWidth}}px</div>
        <div>{{$store.state.offsetHeight}}px</div>
        <div>{{$store.state.offsetWidth}}px</div>
      </van-swipe-item>

    </van-swipe>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import {loadDriverSteps} from "@/utils/DriverSteps";
import {images} from "@/assets/images";
import EvanCalendar from "@/components/EvanCalendar.vue";

export default {
  name: 'HomeView',
  components: {
    EvanCalendar,
    HelloWorld
  },
  computed: {
    images() {
      return images
    },
    routeList() {
      return this.$router.getRoutes().filter(item => item.path && (!item.meta.hasOwnProperty('permission') || item.meta.permission === 'public'));
    },
  },
  data() {
    return {
      imageStyle: {},
      r:[
        {iconClass:'icon-zhangdan',title:'报账单', router: '/bill'},
        {iconClass:'icon-dev-log',title:'开发日志', router: '/development-logs'},
        {iconClass:'icon-device',title:'设备信息', router: '/device-info'},
        {iconClass:'icon-share-s',title:'链接分享', router: '/share'},
        {iconClass:'icon-about',title:'关于我', router: '/about'},
        {iconClass:'icon-more',title:'敬请期待', router: '/'},
        {iconClass:'icon-box',title:'敬请期待', router: '/'},
      ]
    };
  },
  methods:{

    handleResize($event) {
      const innerWidth = $event.target.innerWidth;
      const innerHeight = $event.target.innerHeight;
      if (innerWidth > innerHeight) {
        this.imageStyle = {height: '100%'}
      }else{
        this.imageStyle = {width: '100%'}
      }
    },
    loadGuide() {

    },
  },
  mounted() {
    this.loadGuide();
    window.addEventListener('resize',this.handleResize)
    console.log(this.$router.getRoutes())


  },beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }
}
</script>
<style lang="scss">
.home{
  .van-grid-item{
    & .van-grid-item__content {
      background-color: var(--solid-color);
      border-radius: 1em;
      aspect-ratio: 1/1;
      gap: 5px;
      padding: 8px;
      justify-content: space-between;
      &::after {
        border: none;
      }

      & .van-grid-item__text {
        font-size: .8em;
        color: var(--text-color);
      }
    }
  }
}
.donghua-left {
  animation: fudong-left ease 2s infinite;
  //scale:3 1.5;
  transform-origin: center;
}
.donghua-right {
  animation: fudong-right ease 2s infinite;
  //scale:3 1.5;
  transform-origin: center;
}
@keyframes fudong-left {
  0% {
    color: var(--footer-color);
    transform: translateX(0);
  }
  50%{
    transform: translateX(-100%);
    color: var(--primary-color);
  }
  100%{
    color: var(--footer-color);
    transform: translateX(0);

  }
}
@keyframes fudong-right {
  0% {
    color: var(--footer-color);
    transform: translateX(0);
  }
  50%{
    transform: translateX(100%);
    color: var(--primary-color);
  }
  100%{
    color: var(--footer-color);
    transform: translateX(0);

  }
}

</style>
